import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=4e828267&scoped=true&"
import script from "./Discord.vue?vue&type=script&lang=js&"
export * from "./Discord.vue?vue&type=script&lang=js&"
import style0 from "./Discord.vue?vue&type=style&index=0&id=4e828267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e828267",
  null
  
)

export default component.exports